import {
  INSERT_UPDATE_GUIDELINE_ACTION, GET_GUIDELINE_FILE_ACTION
} from "../../utils/constants";

const initialState = [];

function guidelineReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case INSERT_UPDATE_GUIDELINE_ACTION:
      return [...state, payload];
    case GET_GUIDELINE_FILE_ACTION:
      return [...state, payload];
    default:
      return state;
  }
}

export default guidelineReducer;